import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAdmin from './admin.reducer';

export const selectAdminState = createFeatureSelector<fromAdmin.AdminState>(fromAdmin.adminFeatureKey);

export const selectRegionUpload = createSelector(selectAdminState, state => state.regionUpload);

export const selectYieldCurveUpload = createSelector(selectAdminState, state => state.yieldCurveUpload);

export const selectRegionUploadFileName = createSelector(selectAdminState, fileName => fileName.regionUpload.fileName);

export const selectAdminFiltersAndPage = createSelector(selectAdminState, state => ({
  filters: state.pageFilters,
}));
